export default __webpack_public_path__ + "static/media/Nathan-Anthony.e0813f6e.png";